





















































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import VueQrCode from 'vue-weblineindia-qrcode'
import Form from '@/mixins/form'
import { PatientPostPayload } from '@/api/user/types'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    VueQrCode
  }
})
export default class ManagePatientAdd extends mixins(Form) {
  $store!: ExStore

  inputs: PatientPostPayload = {
    firstName: '',
    lastName: '',
    firstNameReading: '',
    lastNameReading: '',
    patientLocalId: '',
    email: ''
  }

  pendingWorkerInfo = true

  get errorMessages() {
    const { messages } = this.validator
    return Object.keys(messages).reduce(
      (errorMessages, key) =>
        Object.assign(errorMessages, {
          [messages[key]]: messages[key]
        }),
      {} as { [key: string]: string }
    )
  }

  get workerInfo() {
    return this.$store.getters['user/workerInfo']
  }

  handleClickConfirm() {
    if (this.validator.hasAnyError()) {
      return
    }
    this.$store.commit('user/setSessionData', {
      newPatient: { ...this.inputs }
    })
    this.$router.push({ name: 'ManagePatientAddConfirm' })
  }

  created() {
    const editingData = this.$store.getters['user/sessionData'](
      'newPatient'
    ) as PatientPostPayload | null
    if (editingData) {
      this.inputs = editingData
    }

    this.pendingWorkerInfo = false
    this.$store.dispatch('user/updateWorkerInfo').then(() => {
      this.pendingWorkerInfo = false
    })
  }
}
